import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ChipDateRangeSelectData } from '@sb/library/base';
import { SBDate } from '@sb/library/localization';
import { ChipDateRangeSelectPanelComponent } from '../panel/chip-date-range-select-panel.component';

@Component({
    selector: 'lib-chip-date-range-bottom-sheet-panel',
    templateUrl: '../panel/chip-date-range-select-panel.component.html',
})
export class ChipDateRangeSelectBottomSheetComponent extends ChipDateRangeSelectPanelComponent {

    override ngAfterViewInit(): void {
        this.UpdateDatePicker();

        this.closeMenu.subscribe(_ => {
            this.DismissBottomSheet();
        });
    }

    constructor(private _MatBottomSheetRef: MatBottomSheetRef<ChipDateRangeSelectBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: {DateOptions: ChipDateRangeSelectData[], CurrentDateRange: SBDate[], CurrentSelection: ChipDateRangeSelectData}) {
        super();

        this.dateOptions = data.DateOptions;
        this.currentSelection = data.CurrentSelection;
        this.UpdateStartEndDate(data.CurrentDateRange[0], data.CurrentDateRange[1]);

        this._MatBottomSheetRef.afterOpened().subscribe(_ => {
            this.UpdateDatePicker();
        });

        this._MatBottomSheetRef.backdropClick().subscribe(_ => {
            this.DismissBottomSheet();
        });
    }

    override SelectOption(option: ChipDateRangeSelectData): void {
        super.SelectOption(option);
        this.DismissBottomSheet();
    }

    DismissBottomSheet(): void {
        this._MatBottomSheetRef.dismiss({Option: this.currentSelection, DateRange: [this.startSBDate, this.endSBDate]});
    }

}
